import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { IMajSpider, deleteMajSpider, updateMajSpider } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostEditDialog from "../components/PostEditDialog";
import Edit from "./Edit";
import { IMajSpiderEditPayload } from "./interface";
import axios from "axios";


export default function MenuApp(props: any) {
  //props
  const {
    item
  } = props;

  //redux
  const dispatch = useDispatch()


  //hooks
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [editLoading, setEditUserLoading] = useState<boolean>(false);
  const [openEdition, setOpenEdition] = useState<boolean>(false);
  const [editionMajSpider, setEditionMajSpider] = useState<any>({})
  const [selectedFile, setSelectedFile] = useState<any>("")
  const [openSuppression, setOpenSuppression] = useState(false)
  const [suppressionLoading, setSuppressionLoading] = useState(false);
  const [arrayToEdit, setArrayToEdit] = useState<any>([])



  //Ouvrir le menu materialiser par les trois points sur la liste
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu materialiser par les trois points sur la liste
  const handleClose = () => {
    setAnchorEl(null);
  };



  ///////////////////////////////////////// edition  ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet editionMajSpider
  const handleEditionDialogOpen = (item: IMajSpider) => {
    console.log("🚀 ~ file: MenuApp.tsx:60 ~ handleEditionDialogOpen ~ item:", item)
    setOpenEdition(true);
    setEditionMajSpider(item)
    setArrayToEdit(item.VersionDescriptionArray)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionDialogClose = () => {
    setOpenEdition(false);
  };


  // Modifier la mise à jour
  const handlEditActualiteSave = async (e: any) => {
    e.preventDefault();
    try {
      setEditUserLoading(true);

      let VersionDescriptionArray: any = [...arrayToEdit]


      const apiPayload: any = {
        idSpiderVersion: editionMajSpider.idSpiderVersion,
        versionNumber: editionMajSpider.versionNumber,
        versionFileLocation: editionMajSpider.versionFileLocation,
        versionDate: editionMajSpider.versionDate,
      }

      const formData = new FormData();
      Object.keys(apiPayload).forEach((item) => {
        formData.append(item, apiPayload[item]);
      });
      selectedFile && formData.append("file", selectedFile);

      for (const desc of VersionDescriptionArray) {
        formData.append('VersionDescriptionArray', desc);
      }

      const res = await axios.post(`${SITEWEB_SERVER_BASE_URL}/modifierspiderversion`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (res.status === 200) {
        const newVersion = { ...res.data.data, VersionDescriptionArray: JSON.parse(res.data.data.VersionDescriptionArray) }
        dispatch(updateMajSpider(newVersion));
        successNotify("Action éffectuée avec succès");
      } else {
        errorNotify("Echèc de l'opération.");
      }

    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:111 ~ handlEditActualiteSave ~ error:", error)
      errorNotify("Une erreur s'est produite.");
    } finally {
      setEditUserLoading(false);
    }
  };

  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog suppression
  const handleSuppressionDialogOpen = () => {
    setOpenSuppression(true);
  };

  //Fermer la boite de dialog suppression
  const handleSuppressionDialogClose = () => {
    setOpenSuppression(false);
  };

  //Supprimer la mise à jour
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setSuppressionLoading(true);
      //payload
      const apiPayload = {
        idSpiderVersion: item.idSpiderVersion,
        versionFileLocation: item.versionFileLocation,
      };
      // Envoi de la requete vers api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/supprimerspiderversion",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(deleteMajSpider(res.data));
        setSuppressionLoading(false);
        handleSuppressionDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setSuppressionLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:225 ~ handleDelete ~ error:", error)
      setSuppressionLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };




  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >

        <MenuItem
          onClick={() => {
            handleEditionDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleSuppressionDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>
      </Menu>

      {/* editer une majSpider */}
      <PostEditDialog
        onClose={handleEditionDialogClose}
        open={openEdition}
        dialogContent={
          <Edit
            editionMajSpider={editionMajSpider}
            setEditionMajSpider={setEditionMajSpider}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            arrayToEdit={arrayToEdit}
            setArrayToEdit={setArrayToEdit}
          />}
        actionFunc={handlEditActualiteSave}
        title="Edition"
        editLoading={editLoading}
      />

      {/* Supprimer l'majSpider */}
      <ConfirmAction
        title={`Suppression`}
        dialogContent={`Voulez vous réellement supprimer cette mise à jour ?`}
        actionLabel="Oui"
        open={openSuppression}
        handleClose={handleSuppressionDialogClose}
        actionFunction={handleDelete}
        addLoading={suppressionLoading}
        iconeSauveButton={<DeleteIcon />}
      />

    </React.Fragment>
  );
}
